import {ReviewResponsibleUserErrorType} from '../../../../../../../service/reviews/reviews-responsible-users';
import {isRecord} from '../../../../../../../util/object';

export function isReviewResponsibleUserError(error: unknown): error is ReviewResponsibleUserErrorType {
    return isRecord(error) && isRecord(error.jsonData) && Boolean(error.jsonData.status);
}
